module.exports = "<span ng-show=\"$ctrl.value\">{{'Yes_Title' | translate}}</span>\r\n<span ng-hide=\"$ctrl.value\">{{'No_Title' | translate}}</span>"


//////////////////
// WEBPACK FOOTER
// ../widgets/bool-view/bool-view.html
// module id = 751
// module chunks = 0